"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M9.4998 3c-1.7632 0-3.222 1.3038-3.4646 3h-2.013c.2526-2.8032 2.6086-5 5.4776-5 2.869 0 5.225 2.1968 5.4776 5h-2.013c-.2427-1.6962-1.7014-3-3.4646-3z"
  }), _react.default.createElement("path", {
    d: "M9.4998 4c-1.3807 0-2.5 1.1193-2.5 2.5v5.3244l-.0497-.071c-.7411-1.1502-2.272-1.4919-3.4328-.7612-1.158.7288-1.5132 2.251-.8038 3.4158 1.055 1.7284 2.054 3.4954 3.0372 5.2651.5022.904.855 1.5959 1.1354 2.3269H9.005c-.3567-1.1158-.8067-2.0396-1.5059-3.2981-1.4243-2.5637-2.9114-5.0572-3.0506-5.2903-.1458-.2441-.1262-.5629.1342-.7268.2466-.1552.5527-.0605.7024.1773l1.8123 2.5922L9 14.7547 8.9998 6.5a.5.5 0 0 1 1 0v7h2V9.2873l1 .4118V13.5h2v-2.9774l1 .4118V13.5h2v-1.7421l.3808.1568a.9994.9994 0 0 1 .6193.9242v3.7861c0 1.4571-.4389 2.7541-.9264 3.953-.1894.4659-.4081.9675-.5874 1.422h2.1609c.0939-.2225.1882-.4449.2792-.6687.5125-1.2604 1.0737-2.8509 1.0737-4.7063v-3.7861a2.9991 2.9991 0 0 0-1.8578-2.7735l-7.1423-2.941V6.5c0-1.3807-1.1193-2.5-2.5-2.5z"
  })];
};

exports.default = _default;